import React from "react"
import { Col, Row, Form } from "react-bootstrap"
import { Field, getIn } from "formik"
import FormLabel from "./formLabel"

function FormTextbox(props) {
  const { textDesc, form, field, maxLength, toUpperCase } = props

  const errorsMsg = getIn(form.errors, field.name)

  const inputErrorClassName = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  return (
    <div className="marginBottom19px">
      <FormLabel text={textDesc} />
      <div className="marginTop10px">
        <Field
          name={field.name}
          className={
            "d-block inputbox " +
            inputErrorClassName(form.touched, form.errors, field.name)
          }
          type="text"
          onChange={event => {
            let value = event.target.value || ""
            if (toUpperCase) {
              value = value.toUpperCase()
            }
            form.setFieldValue(field.name, value)
          }}
          onBlur={event => {
            form.handleBlur(event)

            let value = event.target.value || ""
            if (toUpperCase) {
              value = value.toUpperCase()
            }
            form.setFieldValue(field.name, value.trim()) // Trim field value when blur
          }}
          maxLength={maxLength}
          autoComplete="new-password"
          value={
            toUpperCase
              ? field.value.toUpperCase()
              : field.value
              ? field.value
              : ""
          }
        />
        {inputErrorMessage(form.touched, form.errors, field.name)}
      </div>
    </div>
  )
}

export default FormTextbox
